/* OTM — Build Your Own Gift Box.
   Adds every chosen product to the cart in one request, each line carrying a
   shared "Gift box" line-item property so the shop packs them together.
   No bundle app in the path: native cart, native inventory, native checkout.

   The builder section carries id="otm-build"; the "Build a box" CTA is a plain
   #otm-build anchor handled natively by the browser — no scroll scripting here. */
(function () {
  if (window.__otmGiftBox) return;
  window.__otmGiftBox = true;

  function money(cents) {
    try {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function boxRef() {
    var d = new Date();
    var stamp = d.getFullYear().toString().slice(2) + String(d.getMonth() + 1).padStart(2, '0') + String(d.getDate()).padStart(2, '0');
    return 'BOX-' + stamp + '-' + Math.random().toString(36).slice(2, 6).toUpperCase();
  }

  function wire(form) {
    var boxes = form.querySelectorAll('input[name="pick"]');
    var countEl = form.querySelector('[data-gb-count]');
    var hintEl = form.querySelector('[data-gb-hint]');
    var btn = form.querySelector('[data-gb-submit]');
    var statusEl = form.querySelector('[data-gb-status]');
    var min = parseInt(form.getAttribute('data-min'), 10) || 3;

    function chosen() {
      return Array.prototype.filter.call(boxes, function (b) { return b.checked; });
    }

    function refresh() {
      var picked = chosen();
      var total = picked.reduce(function (s, b) { return s + Number(b.getAttribute('data-price') || 0); }, 0);
      countEl.textContent = picked.length + ' chosen' + (picked.length ? ' · ' + money(total) : '');
      var short = min - picked.length;
      hintEl.textContent = short > 0 ? ('Pick ' + short + ' more.') : 'Ready to box.';
      btn.disabled = picked.length < min;
    }

    form.addEventListener('change', function (ev) {
      if (ev.target && ev.target.name === 'pick') refresh();
    });

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var picked = chosen();
      if (picked.length < min) return;
      var ref = boxRef();
      var items = picked.map(function (b) {
        return { id: Number(b.value), quantity: 1, properties: { 'Gift box': ref } };
      });
      var label = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = 'Boxing…';
      statusEl.textContent = '';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function (err) {
          btn.disabled = false;
          btn.innerHTML = label;
          statusEl.textContent = (err && err.description) ? err.description : 'Something in the box just sold out. Deselect it and try again.';
        });
    });

    refresh();
  }

  document.querySelectorAll('form[data-otm-giftbox]').forEach(wire);
})();
